export default function findElementDataInScope(elementId, scope = []) {
  const elementScope = scope.find((item) => (item.sourceId === elementId));
  if (!elementScope || !elementScope.data) {
    return {};
  }
  return {
    scopeURN: elementScope.scopeURN,
    scopeData: JSON.parse(elementScope.data),
  };
}
